<template>
  <div>
    <!-- Grid para listar eventos -->
    <Grid
      ref="grid"
      :service="service"
      :route_grid_path="`/teachers/events/statistic/grid`"
      :defaultOrderColumn="'start_at'"
      hide_actions="true"
      :column_formats="{
        start_at: value => this.formatDateTime(value),
        end_at: value => this.formatDateTime(value)
      }"
    >
    </Grid>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import CalendarService from '@/services/api/CalendarService'

export default {
  directives: {
    Ripple
  },
  components: {
    BButton
  },
  data: () => ({
    selected: [],
    service: null
  }),
  computed: {},
  methods: {
    formatDateTime(timestamp) {
      return this.$utils.format.shortDateWithTime(timestamp)
    }
  },
  beforeMount() {
    this.service = CalendarService.build(this.$vs)
  }
}
</script>
